import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/model.ts";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.array.concat.js";
import { combine, createEffect, createEvent, createStore, restore } from 'effector';
import * as estApi from '@gmini/sm-api-sdk/lib/EstimationApi';
import * as smApi from '@gmini/sm-api-sdk';
import { isNotEmpty } from '@gmini/utils';
import { filterNotExistingActive } from '@gmini/ui-kit';
import { prop } from 'ramda';
import { useStore } from 'effector-react';
import { createClassifierService } from "../../classifier-service";
import { createEstimationService } from "../../Services/EstimationService";
import { fromNodeRefsToExplorerRefs, fromTreeData } from "../SelectDependencies/EstimationTree/EstimationTree";
import { createEstimationRepoTreeModel } from "../SelectDependencies/EstimationTree/createTreeModel";
import { createExpandModel, createTreeModel } from "../ClassifierTree";
import { IMPORT_ESTIMATION_FOLDER_CLS_OPENED_KEY } from "./constants";
import { getChildren } from "./helpers/getChildren";
export var createImportEstimationService = function createImportEstimationService() {
  var open = createEvent({
    name: "open",
    sid: "uy9xsu"
  });
  var close = createEvent({
    name: "close",
    sid: "-6jvoae"
  });
  var opened$ = createStore(false, {
    name: "opened$",
    sid: "hekwl0"
  }).on(open, function () {
    return true;
  }).on(close, function () {
    return false;
  }); //TODO: список проектов вынести в отдельный сервис как в ЧиЗ

  var projectList$ = restore(smApi.Project.fetchList.defaultContext.doneData.map(prop('list')), [], {
    name: "projectList$",
    sid: "-v9y3y1"
  });
  var setSelectedProject = createEvent({
    name: "setSelectedProject",
    sid: "-4q13sk"
  });
  var selectedProject$ = restore(setSelectedProject, null, {
    name: "selectedProject$",
    sid: "tqk3s2"
  });
  var estimationService = createEstimationService({
    name: 'importEstimationService'
  });
  selectedProject$.updates.watch(function (project) {
    if (!project) {
      return;
    }

    loadNodes({
      nodes: [],
      projectUrn: project.urn
    });
  });
  var tree$ = createEstimationRepoTreeModel(estimationService, selectedProject$.map(function (project) {
    return project ? project.urn : null;
  }));
  var fetchDynamicGroupItemActiveEstimation = smApi.UserClassifierTree.DynamicGroupItem.getList.createContext();
  var fetchGroupTree = smApi.UserClassifierTree.GroupItem.getList.createContext();
  var fetchActiveEstimation = estApi.Estimation.getMostRecent.createContext();
  var fetchActiveEstimationPending$ = fetchActiveEstimation.pending$;
  var activeEstimation$ = createStore(null, {
    name: "activeEstimation$",
    sid: "-dlz80k"
  }).on(fetchActiveEstimation.doneData, function (state, payload) {
    if (state) {
      return _objectSpread(_objectSpread({}, state), payload);
    }

    return payload;
  }).on(fetchDynamicGroupItemActiveEstimation.doneData, function (state, result) {
    if (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        dynamicGroupList: result.dynamicGroupList
      });
    }

    return {
      dynamicGroupList: result.dynamicGroupList
    };
  });
  var classifierService = createClassifierService({
    name: 'importEstimationsClassifierService',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    apiErrMessageMap: {} //TODO: add error messages

  });
  var activeCurrentClassifier$ = createStore(null, {
    name: "activeCurrentClassifier$",
    sid: "x6omky"
  }).on(combine({
    ɔ: [classifierService.userClassifier.nodes$, activeEstimation$, function (nodes, activeEstimation) {
      if (!activeEstimation || !activeEstimation.classifierId) {
        return null;
      }

      var userClassifierNode = nodes[activeEstimation.classifierId];

      if (!userClassifierNode) {
        return null;
      }

      return userClassifierNode;
    }],
    config: {
      name: "activeCurrentClassifier$",
      sid: "-o36aiz"
    }
  }).updates, function (_state, payload) {
    return payload;
  });
  var fetchPriorityOrder = smApi.UserClassifierPriorityOrder.GetAll.fetch.createContext();
  var fetchActiveEstimationData = createEffect( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
      var classifierId, userClassifier;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              classifierId = _ref.classifierId;
              setActiveEstimationDataPending(true);
              _context.prev = 2;
              _context.next = 5;
              return smApi.UserClassifier.getMostRecent.defaultContext({
                id: classifierId
              });

            case 5:
              userClassifier = _context.sent;
              _context.next = 8;
              return Promise.all([smApi.UserClassifier.fetchFlatListItems.defaultContext({
                classifierId: classifierId,
                classifierVersion: userClassifier.version,
                skipRef: true
              }), fetchDynamicGroupItemActiveEstimation({
                classifierId: classifierId,
                classifierVersion: userClassifier.version
              }), fetchGroupTree({
                classifierId: classifierId,
                classifierVersion: userClassifier.version
              }), fetchPriorityOrder({
                classifierId: classifierId,
                classifierVersion: userClassifier.version
              })]);

            case 8:
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              console.error('fetchActiveEstimationData error', _context.t0);

            case 13:
              _context.prev = 13;
              setActiveEstimationDataPending(false);
              return _context.finish(13);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 10, 13, 16]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), {
    name: "fetchActiveEstimationData",
    sid: "knqlyh"
  });
  fetchActiveEstimation.doneData.watch(function (estimation) {
    if (!estimation.classifierId) {
      return;
    }

    fetchActiveEstimationData({
      classifierId: estimation.classifierId
    });
  });
  var setActiveEstimationDataPending = createEvent({
    name: "setActiveEstimationDataPending",
    sid: "f7nr0y"
  });
  var fetchActiveEstimationDataPending$ = createStore(false, {
    name: "fetchActiveEstimationDataPending$",
    sid: "-n4evvf"
  }).on(setActiveEstimationDataPending, function (_state, payload) {
    return payload;
  });
  var expandModel = createExpandModel();
  var setPreloadPending = createEvent({
    name: "setPreloadPending",
    sid: "vjaq51"
  });
  var resetPreloadPending = createEvent({
    name: "resetPreloadPending",
    sid: "-6tirkg"
  });
  var preloadPending$ = restore(setPreloadPending, true, {
    name: "preloadPending$",
    sid: "-r5bj8x"
  }).on(resetPreloadPending, function () {
    return true;
  });
  var ruleGroupIds$ = activeEstimation$.map(function (m) {
    var _m$calculations;

    return (m === null || m === void 0 ? void 0 : (_m$calculations = m.calculations) === null || _m$calculations === void 0 ? void 0 : _m$calculations.map(function (_ref3) {
      var groupId = _ref3.groupId;
      return groupId;
    }).filter(isNotEmpty)) || [];
  });
  var groupTree$ = createStore([], {
    name: "groupTree$",
    sid: "88r7i1"
  }).on(fetchGroupTree.doneData, function (_, _ref4) {
    var groupTree = _ref4.groupTree;
    return groupTree;
  });

  var useChildrenHasRule = function useChildrenHasRule() {
    var tree = useStore(groupTree$);
    var ruleGroupIds = useStore(ruleGroupIds$);
    return function (id) {
      var children = getChildren(tree, id);
      return children.some(function (item) {
        return ruleGroupIds.some(function (ruleGroupId) {
          return item.id === ruleGroupId;
        });
      });
    };
  };

  var loadNodes = createEffect({
    handler: function handler(_ref5) {
      var nodes = _ref5.nodes,
          projectUrn = _ref5.projectUrn;
      var opened = nodes;
      var items = Object.values(opened).filter(isNotEmpty);
      var repoProm = estApi.EstimationRepo.Populated.fetch.defaultContext({
        projectUrn: projectUrn
      });
      var promises = items.map( /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(nRef) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.t0 = nRef.type;
                  _context2.next = _context2.t0 === 'EstimationNode' ? 3 : _context2.t0 === 'EstimationRepoFolderNode' ? 6 : 8;
                  break;

                case 3:
                  _context2.next = 5;
                  return fetchActiveEstimation({
                    id: nRef.id
                  });

                case 5:
                  return _context2.abrupt("return");

                case 6:
                  _context2.next = 8;
                  return estApi.EstimationRepoFolder.Populated.fetch.defaultContext({
                    id: nRef.id
                  });

                case 8:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref6.apply(this, arguments);
        };
      }()); // eslint-disable-next-line @typescript-eslint/no-explicit-any

      return Promise.all([].concat(_toConsumableArray(promises), [repoProm]))["finally"](function () {
        return setPreloadPending(false);
      });
    }
  }, {
    name: "loadNodes",
    sid: "jp1n96"
  });

  function getFromPersist() {
    try {
      var raw = localStorage.getItem(IMPORT_ESTIMATION_FOLDER_CLS_OPENED_KEY);
      return JSON.parse(raw || '[]');
    } catch (err) {
      return [];
    }
  }

  function saveToPersist(nodes) {
    localStorage.setItem(IMPORT_ESTIMATION_FOLDER_CLS_OPENED_KEY, JSON.stringify(nodes));
  }

  function initTree(_x3, _x4) {
    return _initTree.apply(this, arguments);
  }

  function _initTree() {
    _initTree = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(projectUrn, tree$) {
      var fromPersist, treeData, explorerTree, actual;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              fromPersist = getFromPersist();
              _context3.next = 3;
              return loadNodes({
                nodes: fromPersist,
                projectUrn: projectUrn
              });

            case 3:
              treeData = tree$.getState();
              explorerTree = fromTreeData(treeData);
              actual = filterNotExistingActive(explorerTree, fromNodeRefsToExplorerRefs(fromPersist));
              return _context3.abrupt("return", actual);

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _initTree.apply(this, arguments);
  }

  var treeModel = createTreeModel({
    currentUserClassifier$: activeCurrentClassifier$,
    nodes$: classifierService.nodes$,
    onCreatedNode: smApi.UserClassifierGroup.create.done,
    dynamicMode$: createStore(false, {
      name: "dynamicMode$",
      sid: "k4d98e"
    }),
    treeOrderMapTriggers: [fetchPriorityOrder.doneData]
  });
  return {
    open: open,
    close: close,
    opened$: opened$,
    activeEstimation$: activeEstimation$,
    preloadPending$: preloadPending$,
    resetPreloadPending: resetPreloadPending,
    setPreloadPending: setPreloadPending,
    loadNodes: loadNodes,
    getFromPersist: getFromPersist,
    saveToPersist: saveToPersist,
    initTree: initTree,
    fetchActiveEstimation: fetchActiveEstimation,
    projectList$: projectList$,
    tree$: tree$,
    setSelectedProject: setSelectedProject,
    selectedProject$: selectedProject$,
    fetchActiveEstimationPending$: fetchActiveEstimationPending$,
    expandModel: expandModel,
    classifierService: classifierService,
    activeCurrentClassifier$: activeCurrentClassifier$,
    fetchActiveEstimationDataPending$: fetchActiveEstimationDataPending$,
    treeModel: _objectSpread(_objectSpread({}, treeModel), {}, {
      flatTree$: treeModel.flatTree$.map(function (flatTree) {
        return flatTree.filter(function (_ref7) {
          var type = _ref7.ref.type;
          return type !== 'CreateNode';
        });
      })
    }),
    estimationService: estimationService,
    setActiveEstimationDataPending: setActiveEstimationDataPending,
    fetchDynamicGroupItemActiveEstimation: fetchDynamicGroupItemActiveEstimation,
    useChildrenHasRule: useChildrenHasRule,
    fetchActiveEstimationData: fetchActiveEstimationData
  };
};
export var importEstimationService = createImportEstimationService();